module.exports = __webpack_public_path__ + "img/整体选择2.1f3f79dd.svg";